import "./App.scss";
import Home from "./sections/home/home";
import Kzen8ForBusinesses from "./sections/kzen8-for-businesses/kzen8-for-businesses";
import TopBar from "./components/top-bar/top-bar";
import WhatOthersSay from "./sections/what-others-say/what-others-say";
import Footer from "./sections/footer/footer";
import { Routes, Route } from "react-router-dom";
import AboutUs from "./pages/about-us/about-us";
import Solutions from "./pages/solutions/solutions";
import JobManagement from "./pages/solutions/job-management/job-management";
import CustomerRelationships from "./pages/solutions/customer-relationships/customer-relationships";
import Careers from "./pages/careers/careers";
import NotFound from "./pages/not-found/not-found";
import ContactUs from "./pages/contact-us/contact-us";
import BackgroundWithShapes from "./components/background-with-shapes/background-with-shapes";
import WhatCanYouBuild from "./sections/what-can-you-build/what-can-you-build";
import EndlessPossibilities from "./sections/endless-possibilities/endless-possibilities";
import { useEffect } from "react";
import Features from "./sections/features/features";
import Kzen8ForIndustryExperts from "./sections/kzen8-for-industry-experts/kzen8-for-industry-experts";
import LoadingScreen from "./sections/loading-screen/loading-screen";
import { useState } from "react";
import UserPreferenceContext from "./contexts/user-preference-context";
import { visibilityCheck } from "./utils/visibility-check";
import { AiOutlineReload } from "react-icons/ai";
import Kzen8ForIndustryExpertsTwo from "./sections/kzen8-for-industry-experts-two/kzen8-for-industry-experts-two";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "@react-hook/window-size";
import { Button } from "@mui/material";
import { PlayCircleFilledTwoTone } from "@mui/icons-material";
import { FaClock } from "react-icons/fa";
import DomainFees from "./pages/domain-fees/domain-fees";
import PartnerLevels from "./pages/partner-levels/partner-levels";
import BecomeAKzenPartner from "./pages/become-a-kzen-partner/become-a-kzen-partner";
import Marquee from "react-fast-marquee";
import BusinessAssessment from "./pages/business-assessment/business-assessment";
import CountUp from "react-countup";

function App() {
  function setVw() {
    let vw = document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }

  const [width, height] = useWindowSize();

  const [userPreference, setUserPreference] = useState('O');

  setVw();
  window.addEventListener("resize", setVw);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <UserPreferenceContext.Provider value={'O'}>
      <div className="App">
        {userPreference ? (
          <>
            <div className="spinner"></div>
            <div className="app-container">
              <TopBar setUserPreference={setUserPreference} />
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <>
                      {/* <img src="/images/wave-1.svg" className="backgroundColourWave1"></img> */}
                      <Home />
                      <div className="awsPartnerBadges green full-width-element">
                        <h1 className="header app-background-text-colour ">AWS Certified Solution Provider</h1>
                        <div className="badgeContainer">
                          <img src="/images/badge.png" />
                          <img src="/images/badge2.png" />
                          <img src="/images/badge3.png" />
                          <div style={{background: 'rgba(255,255,255,0.25)', padding: '1rem', borderRadius: '1rem'}}>
                            <img src="/images/gch_logo.png" />
                          </div>

                        </div>


                      </div>
                      <Kzen8ForIndustryExperts />
                      {/* <div className="Solutions home-page-located full-width-element" style={{ minHeight: '50vh' }}>
                        <div className="topDescription app-background-text-colour">
                          <img src="/images/Dotted-random-pattern.svg" className="dotted-random-pattern" />
                          <section className="left">
                            <h1 className="bigHeading">Solutions built With Kzen8</h1>
                            <h2 className="body">Implement solutions that utilise state of the art techonology and provide the following benefits:</h2>

                            <div className="statsContainer">
                              <div className="stats">
                                <h1 className="header">
                                  <CountUp end={10} duration={0.75} />x
                                </h1>
                                <span className={width > 500 ? "subtitle2" : "subinfo"}>Faster development</span>
                              </div>
                              <div className="stats">
                                <h1 className="header">
                                  <CountUp end={4} duration={0.25} />x
                                </h1>
                                <span className={width > 500 ? "subtitle2" : "subinfo"}>Resources saved</span>
                              </div>
                              <div className="stats">
                                <h1 className="header">
                                  <CountUp end={3} duration={0.15} />x
                                </h1>
                                <span className={width > 500 ? "subtitle2" : "subinfo"}>Less downtime</span>
                              </div>
                            </div>
                          </section>
                          <section className="right"></section>
                          <img src="/images/solutions-hero-image.webp" alt="solutions hero page" className="heroImage" />
                        </div>
                      </div> */}

                      <div className="arrow-group full-width-element">
                        <h1 className="bigHeading secondary-text">Steamlining Nursing Placements</h1>

                        <div className="arrow-group-container">
                          <div className="arrow">
                            <img src="/images/Arrow-1.svg" />
                          </div>

                          <div className="arrow">
                            <img src="/images/Arrow-2.svg" />
                          </div>


                          <div className="arrow">
                            <img src="/images/Arrow-3.svg" />
                          </div>





                        </div>
                      </div>
                      {/* <Solutions /> */}

                      {/* <div className="awsPartnerBadges full-width-element">
                        <h1 className="header">AWS Certified Solution Provider</h1>
                        <div className="badgeContainer ">
                          <img src="/images/badge.png" />
                          <img src="/images/badge2.png" />
                          <img src="/images/badge3.png" />
                        </div>


                      </div> */}
                    </>
                  }
                ></Route>
                <Route path="our-story" element={<AboutUs />}></Route>
                <Route path="contact-us" element={<ContactUs />}></Route>
                <Route exact path="solutions" element={<Solutions />}></Route>
                <Route exact path="business-assessment" element={<BusinessAssessment />}></Route>
                <Route exact path="pricing" element={<DomainFees />}></Route>
                <Route exact path="compare-partner-levels" element={<PartnerLevels />}></Route>

                <Route path="solutions/job-management" element={<JobManagement />}></Route>
                <Route path="solutions/customer-relationships" element={<CustomerRelationships />}></Route>

                <Route path="careers" element={<Careers />}></Route>
                <Route path="partner" element={<BecomeAKzenPartner />}></Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
              <BackgroundWithShapes />
            </div>

            <Footer />
          </>
        ) : (
          <LoadingScreen setUserPreference={setUserPreference} />
        )}
      </div>
    </UserPreferenceContext.Provider>
  );
}

export default App;
